import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import WebService from "../../../../../utility/WebService";
import { Controller, useForm } from "react-hook-form";
import loader from "../../../../../assets/images/button-loader.svg"
import BackComponent from "../../../../../components/BackArrow";
import { Label } from "../../../../../components/Label/Label";
import WarningModal from "../../../../../components/Warning/Warning";
import SucessModal from "../../../../../components/SucessModal/Sucess";
import CustomDropdown, { Options } from "../../../../../components/Select/CustomDropdown";

const AddFixedReturnandRetirementProducts = () => {
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        control,
        formState: { errors },
    } = useForm();
    const watchAllFields = watch();
    const [isLoading, setLoading] = useState(false);
    const [bankNameOption, setBankNameOption] = useState<any[]>([]);
    const [bankValue, setBankValue] = useState<any[]>([]);
    const [financialInstituteOption, setFinancialInstituteOption] = useState<any[]>([]);
    const [financialInstituteValue, setFinancialInstituteValue] = useState<any[]>([]);
    const [publicCompanyOption, setPublicCompanyOption] = useState<any[]>([]);
    const [publicCompanyValue, setPublicCompanyValue] = useState<any[]>([]);
    const [insuranceCompanyOption, setInsuranceCompanyOption] = useState<any[]>([]);
    const [insuranceCompanyValue, setInsuranceCompanyValue] = useState<any[]>([]);
    const [p2pLenderOption, setp2pLenderOption] = useState<any[]>([]);
    const [p2pLenderValue, setP2pLenderValue] = useState<any[]>([]);
    const [bondsandDebentureOption, setBondsandDebentureOption] = useState<any[]>([]);
    const [bondsandDebentureValue, setBondsandDebentureValue] = useState<any[]>([]);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [productCategories, setProductCategories] = useState<any>([]);
    const [issuerData, setIssuerData] = useState<any>([]);
    const [vendorLockingSelected, setVendorLockingSelected] = useState<any[]>([]);
    const [lockingIncomeTaxSelected, setLockingIncomeTaxSelected] = useState<any[]>([]);

    let { id } = useParams();

    useEffect(() => {
        if (id) {
            getDetail();
        }
        getProductCategoriesList()
        getIssuerList();
        getBankList();
        getFinancialInstituteList();
        getPublicCompanyList();
        getInsuranceCompanyList();
        getP2pLenderList();
        getBondsandDebentureList();
    }, []);

    const onSave = (data: any) => {
        setLoading(true);
        if (id) {
            WebService.putAPI({
                action: `/v2/CommonProductParameters/AddData`,
                body: data,
            })
                .then((res: any) => {
                    setShowSucessModal(true);
                    setSucessMessage(res.message)
                    goBack();
                })
                .catch((e) => {
                    setShowWarningModal(true);
                    setWarningMessage(e.response.data.message)
                    setLoading(false);
                });
        } else {
            WebService.postAPI({
                action: `/v2/CommonProductParameters/AddData`,
                body: data,
            })
                .then((res: any) => {
                    setShowSucessModal(true);
                    setSucessMessage(res.message)
                    goBack();
                })
                .catch((e) => {
                    setShowWarningModal(true);
                    setWarningMessage(e.response.data.message)
                    setLoading(false);
                });
        }
    };

    const getProductCategoriesList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/ProductParameteTypeList`,
        })
            .then((res: any) => {
                setProductCategories(res.list)
            })
            .catch((e) => {
            });
    };

    const getIssuerList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/IssuerCategoryList`,
        })
            .then((res: any) => {
                setIssuerData(res.list)
            })
            .catch((e) => {
            });
    };

    const getBankList = () => {
        WebService.postAPI({
            action: `/v2/BankList/getlist`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].bank_list_id, value: res.list[i].name });
                }
                setBankNameOption(array);
            })
            .catch((e) => { });
    };

    const getFinancialInstituteList = () => {
        WebService.postAPI({
            action: `/v2/FinancialInstituteType/GetList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].financial_institute_type_id, value: res.list[i].name });
                }
                setFinancialInstituteOption(array);
            })
            .catch((e) => { });
    };

    const getPublicCompanyList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/GetList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setPublicCompanyOption(array);
            })
            .catch((e) => { });
    };

    const getInsuranceCompanyList = () => {
        WebService.postAPI({
            action: `/v2/UlipProductParameters/GetInsuranceCompanyList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setInsuranceCompanyOption(array);
            })
            .catch((e) => { });
    };

    const getP2pLenderList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/GetLenderList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setp2pLenderOption(array);
            })
            .catch((e) => { });
    };

    const getBondsandDebentureList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/GetBondsAndDebenturesTypeList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setBondsandDebentureOption(array);
            })
            .catch((e) => { });
    };

    const vendorLockingOptions: Options[] = [
        { id: "Year", value: "Year" },
        { id: "Month", value: "Month" },
        { id: "Day", value: "Day" },
        { id: "Description", value: "Description" },
    ];

    const compoundingFrequencyOptions: Options[] = [
        { id: "Yearly", value: "Yearly" },
        { id: "Half-Yearly", value: "Half-Yearly" },
        { id: "Quarterly", value: "Quarterly" },
        { id: "Monthly", value: "Monthly" },
        { id: "NA", value: "NA" },
    ];

    const getDetail = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/GetDetail?id=${id}`,
        })
            .then((res: any) => {
                reset(res.result);
                setBondsandDebentureValue(res.result.bonds_and_debentures_type_id);
                setBankValue(res.result.bank_id);
                setFinancialInstituteValue(res.result.financial_institute_type_id);
                setPublicCompanyValue(res.result.share_company_id);
                setInsuranceCompanyValue(res.result.insurance_company_id);
                setP2pLenderValue(res.result.table_id);
                setVendorLockingSelected(res.result.locking_period_by_vendor_term);
                setLockingIncomeTaxSelected(res.result.locking_period_by_income_tax_term)
            })
            .catch((e) => {
                setShowWarningModal(true);
                setWarningMessage(e.response.data.message)
            });
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setLoading(false);
    }

    const goBack = () => {
        window.history.back();
    };
    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <div className="page-content-wraper">
                <form onSubmit={handleSubmit(onSave)}>
                    <div className="grid grid-cols-2 gap-4 mb-3">
                        <div>
                            {" "}
                            <BackComponent
                                title={id ? "Edit Fixed Return & Retirement Product " : " Add Fixed Return & Retirement Product"}
                            />
                        </div>
                    </div>
                    <div className="rounded-xl bg-white p-4 form-style mb-2">
                        <div className=" grid grid-cols-12 gap-4 form-style">
                            <div className=" col-span-3">
                                <label className="label">
                                    Product Category  <span className=" text-red-600">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    {...register("product_parameter_type", {
                                        required: true,
                                    })}
                                    onChange={(e) => {
                                        setValue('product_parameter_type', e.target.value)
                                        setValue('issuer_category', null)
                                    }}>
                                    {productCategories &&
                                        productCategories.length > 0 &&
                                        productCategories.map((res: any) => {
                                            return (
                                                <>
                                                    <optgroup label={res.name} >
                                                        <option value={''}>Select</option>
                                                        {res &&
                                                            res.list.length > 0 &&
                                                            res.list.map((item: any) => {
                                                                return (
                                                                    <>
                                                                        <option value={item.id}>{item.name}</option>
                                                                    </>
                                                                );
                                                            })}
                                                    </optgroup>
                                                </>
                                            );
                                        })}
                                </select>
                                <div>
                                    {errors.product_parameter_type && (
                                        <Label
                                            title={"Please Enter Product Category."}
                                            modeError={true}
                                        />
                                    )}
                                </div>
                            </div>

                            {watchAllFields.product_parameter_type == "Debentures" &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        Bonds & Debentures Type <span className=" text-red-600">*</span>
                                    </label>
                                    <div className="mb-2">
                                        <Controller
                                            control={control}
                                            name="bonds_and_debentures_type_id"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <CustomDropdown
                                                    isSearchable={true}
                                                    options={bondsandDebentureOption}
                                                    selected={bondsandDebentureValue}
                                                    onChange={(data: any) => {
                                                        field.onChange(data.id)
                                                        setBondsandDebentureValue(data.id);
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div>
                                        {errors.bonds_and_debentures_type_id && (
                                            <Label
                                                title={"Please Select Bonds & Debentures Type ."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "Recurring" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "POMIS" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "NPS" || watchAllFields.product_parameter_type == "Superannuation") &&
                                <div className=" col-span-5">
                                    <div className="">
                                        <label className=" mb-0 mr-4">Issuer<span className=" text-red-600">*</span></label>
                                        <div className="flex mt-3">
                                            {issuerData &&
                                                issuerData.length > 0 &&
                                                issuerData.map((res: any) => {
                                                    return (
                                                        <>
                                                            <div className="flex items-center mr-4">
                                                                <input
                                                                    id={res.name}
                                                                    type="radio"
                                                                    value={res.name}
                                                                    className="custom-radio"
                                                                    {...register("issuer_category", {
                                                                        required: true,
                                                                    })}
                                                                />
                                                                <label htmlFor={res.name} className="block text-sm font-medium text-gray-700">{res.name}</label>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                    <div>
                                        {errors.issuer_category && (
                                            <Label
                                                title={"Please Select Issuer."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {(watchAllFields.issuer_category == 'Bank') &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        Bank<span className=" text-red-600">*</span>
                                    </label>
                                    <div className="mb-2">
                                        <Controller
                                            control={control}
                                            name="bank_id"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <CustomDropdown
                                                    isSearchable={true}
                                                    options={bankNameOption}
                                                    selected={bankValue}
                                                    onChange={(data: any) => {
                                                        field.onChange(data.id)
                                                        setBankValue(data.id)
                                                            ;
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div>
                                        {errors.bank_id && (
                                            <Label
                                                title={"Please Select Bank."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {watchAllFields.issuer_category == 'Financial Institute' &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        Financial Institute<span className=" text-red-600">*</span>
                                    </label>
                                    <div className="mb-2">
                                        <Controller
                                            control={control}
                                            name="financial_institute_type_id"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <CustomDropdown
                                                    isSearchable={true}
                                                    options={financialInstituteOption}
                                                    selected={financialInstituteValue}
                                                    onChange={(data: any) => {
                                                        field.onChange(data.id)
                                                        setFinancialInstituteValue(data.id);
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div>
                                        {errors.financial_institute_type_id && (
                                            <Label
                                                title={"Please Select Financial Institute."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {watchAllFields.issuer_category == 'Public Company' &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        Public Company<span className=" text-red-600">*</span>
                                    </label>
                                    <div className="mb-2">
                                        <Controller
                                            control={control}
                                            name="share_company_id"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <CustomDropdown
                                                    isSearchable={true}
                                                    options={publicCompanyOption}
                                                    selected={publicCompanyValue}
                                                    onChange={(data: any) => {
                                                        field.onChange(data.id)
                                                        setPublicCompanyValue(data.id);
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div>
                                        {errors.share_company_id && (
                                            <Label
                                                title={"Please Select Public Company."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {watchAllFields.issuer_category == 'Insurance Company' &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        Insurance Company<span className=" text-red-600">*</span>
                                    </label>
                                    <div className="mb-2">
                                        <Controller
                                            control={control}
                                            name="insurance_company_id"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <CustomDropdown
                                                    isSearchable={true}
                                                    options={insuranceCompanyOption}
                                                    selected={insuranceCompanyValue}
                                                    onChange={(data: any) => {
                                                        field.onChange(data.id)
                                                        setInsuranceCompanyValue(data.id);
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div>
                                        {errors.insurance_company_id && (
                                            <Label
                                                title={"Please Select Insurance Company."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {watchAllFields.issuer_category == 'P2P Lender' &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        P2P Lender<span className=" text-red-600">*</span>
                                    </label>
                                    <div className="mb-2">
                                        <Controller
                                            control={control}
                                            name="table_id"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <CustomDropdown
                                                    isSearchable={true}
                                                    options={p2pLenderOption}
                                                    selected={p2pLenderValue}
                                                    onChange={(data: any) => {
                                                        field.onChange(data.id)
                                                        setP2pLenderValue(data.id);
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div>
                                        {errors.table_id && (
                                            <Label
                                                title={"Please Select P2P Lender."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "Recurring" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "POMIS" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "NPS" || watchAllFields.product_parameter_type == "Superannuation")
                                &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        Product  Name<span className=" text-red-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Product Name"
                                        {...register("product_name", {
                                            required: true,
                                        })}
                                    />
                                    <div>
                                        {errors.product_name && (
                                            <Label
                                                title={"Please Enter Product Name."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {(watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "PPF") &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        ISIN Code
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="ISIN Code"
                                        {...register("isin_code")}
                                    />
                                </div>
                            }

                            {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Sukanya Samriddhi" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "PPF" || watchAllFields.product_parameter_type == "NPS" || watchAllFields.product_parameter_type == "Superannuation") &&
                                <div className=" col-span-2">
                                    <div className="">
                                        <label className=" mb-0 mr-4"> 80C Benefit<span className=" text-red-600">*</span></label>
                                        <div className="flex mt-3">
                                            <div className="flex items-center mr-4">
                                                <input
                                                    id={'Yes_'}
                                                    type="radio"
                                                    value="Yes"
                                                    className="custom-radio"
                                                    {...register("benefit_80C", {
                                                        required: true,
                                                    })}
                                                />
                                                <label htmlFor="Yes_" className="block text-sm font-medium text-gray-700">Yes</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    id={'No_'}
                                                    type="radio"
                                                    value={'No'}
                                                    className="custom-radio"
                                                    {...register("benefit_80C", {
                                                        required: true,
                                                    })}
                                                />
                                                <label htmlFor="No_" className="ml-3 block text-sm font-medium text-gray-700">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {errors.benefit_80C && (
                                            <Label title={"Please Select 80C Benefit."} modeError={true} />
                                        )}
                                    </div>
                                </div>
                            }

                            <div className=" col-span-3">
                                <label className="label">
                                    Locking Period By Vendor<span className=" text-red-600">*</span>
                                </label>
                                <div className="mb-2" style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "35%", marginRight: 12 }}
                                        type="text"
                                        className="form-control"
                                        {...register("locking_period_by_vendor", {
                                            required: true,
                                        })}
                                    />
                                    <Controller
                                        control={control}
                                        name="locking_period_by_vendor_term"
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <CustomDropdown
                                                isSearchable={true}
                                                options={vendorLockingOptions}
                                                selected={vendorLockingSelected}
                                                onChange={(data: any) => {
                                                    field.onChange(data.id)
                                                    setVendorLockingSelected(data.id)
                                                        ;
                                                }}
                                            />
                                        )}
                                    />

                                </div>
                                <div>
                                    {errors.locking_period_by_vendor && (
                                        <Label
                                            title={"Please Enter Vendor Locking Period."}
                                            modeError={true}
                                        />
                                    )}
                                </div>
                                <div>
                                    {errors.locking_period_by_vendor_term && (
                                        <Label
                                            title={"Please Select Vendor Locking Period."}
                                            modeError={true}
                                        />
                                    )}
                                </div>
                            </div>

                            {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "Recurring" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "POMIS" || watchAllFields.product_parameter_type == "Sukanya Samriddhi" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "PPF" || watchAllFields.product_parameter_type == "Superannuation") &&
                                <div className=" col-span-3">
                                    <label className="label">
                                        Locking Period By Income Tax<span className=" text-red-600">*</span>
                                    </label>
                                    <div className="mb-2" style={{ display: 'flex' }}>
                                        <input
                                            style={{ width: "35%", marginRight: 12 }}
                                            type="text"
                                            className="form-control"
                                            {...register("locking_period_by_income_tax", {
                                                required: true,
                                            })}
                                        />
                                        <Controller
                                            control={control}
                                            name="locking_period_by_income_tax_term"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <CustomDropdown
                                                    isSearchable={true}
                                                    options={vendorLockingOptions}
                                                    selected={lockingIncomeTaxSelected}
                                                    onChange={(data: any) => {
                                                        field.onChange(data.id)
                                                        setLockingIncomeTaxSelected(data.id)
                                                            ;
                                                    }}
                                                />
                                            )}
                                        />

                                    </div>
                                    <div>
                                        {errors.locking_period_by_income_tax && (
                                            <Label
                                                title={"Please Enter Locking Period By Income Tax."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        {errors.locking_period_by_income_tax_term && (
                                            <Label
                                                title={"Please Select Locking Period By Income Tax."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>}

                            <div className=" col-span-2">
                                <div className="">
                                    <label className=" mb-0 mr-4">Recommendation<span className=" text-red-600">*</span></label>
                                    <div className="flex mt-3">
                                        <div className="flex items-center mr-4">
                                            <input
                                                id={'Yes'}
                                                type="radio"
                                                value="Yes"
                                                className="custom-radio"
                                                {...register("recommendation", {
                                                    required: true,
                                                })}
                                            />
                                            <label htmlFor="Yes" className="block text-sm font-medium text-gray-700">Yes</label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id={'No'}
                                                type="radio"
                                                value={'No'}
                                                className="custom-radio"
                                                {...register("recommendation", {
                                                    required: true,
                                                })}
                                            />
                                            <label htmlFor="No" className="ml-3 block text-sm font-medium text-gray-700">No</label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id={'NA_'}
                                                type="radio"
                                                value={'NA'}
                                                className="custom-radio"
                                                {...register("recommendation", {
                                                    required: true,
                                                })}
                                            />
                                            <label htmlFor="NA_" className="ml-3 block text-sm font-medium text-gray-700">NA</label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {errors.recommendation && (
                                        <Label title={"Please Select Recommendation."} modeError={true} />
                                    )}
                                </div>
                            </div>

                            {(watchAllFields.product_parameter_type == "Sukanya Samriddhi" || watchAllFields.product_parameter_type == "PPF") &&
                                <div className=" col-span-2">
                                    <div className="">
                                        <label className=" mb-0 mr-4">Is loan facility available?<span className=" text-red-600">*</span></label>
                                        <div className="flex mt-3">
                                            <div className="flex items-center mr-4">
                                                <input
                                                    id={'Yes_s'}
                                                    type="radio"
                                                    value="Yes"
                                                    className="custom-radio"
                                                    {...register("is_loan_facility_avaliable", {
                                                        required: true,
                                                    })}
                                                />
                                                <label htmlFor="Yes_s" className="block text-sm font-medium text-gray-700">Yes</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    id={'No_o'}
                                                    type="radio"
                                                    value={'No'}
                                                    className="custom-radio"
                                                    {...register("is_loan_facility_avaliable", {
                                                        required: true,
                                                    })}
                                                />
                                                <label htmlFor="No_o" className="ml-3 block text-sm font-medium text-gray-700">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {errors.is_loan_facility_avaliable && (
                                            <Label title={"Please Select Is loan facility available."} modeError={true} />
                                        )}
                                    </div>
                                </div>
                            }

                            {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Sukanya Samriddhi" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "Recurring" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "PPF") &&
                                <div className=" col-span-5">
                                    <div className="">
                                        <label className=" mb-0 mr-4">Compounding Frequency<span className=" text-red-600">*</span></label>
                                        <div className="flex mt-3">
                                            {compoundingFrequencyOptions &&
                                                compoundingFrequencyOptions.length > 0 &&
                                                compoundingFrequencyOptions.map((res: any) => {
                                                    return (
                                                        <>
                                                            <div className="flex items-center mr-4">
                                                                <input
                                                                    id={res.value}
                                                                    type="radio"
                                                                    value={res.value}
                                                                    className="custom-radio"
                                                                    {...register("compounding_frequency", {
                                                                        required: true,
                                                                    })}
                                                                />
                                                                <label htmlFor={res.value} className="block text-sm font-medium text-gray-700">{res.value}</label>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                        </div>
                                    </div>

                                    <div>
                                        {errors.compounding_frequency && (
                                            <Label
                                                title={"Please Select Compounding Frequency."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                            }

                            {(watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "POMIS" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme") &&
                                <div className=" col-span-2">
                                    <div className="">
                                        <label className=" mb-0 mr-4">Interest Payout Date<span className=" text-red-600">*</span></label>
                                        <div className="flex mt-3">
                                            <div className="flex items-center mr-4">
                                                <input
                                                    id={'Start_date'}
                                                    type="radio"
                                                    value={'Start Date'}
                                                    className="custom-radio"
                                                    {...register("interest_payout_date", {
                                                        required: true,
                                                    })}
                                                />
                                                <label htmlFor="Start_date" className="ml-3 block text-sm font-medium text-gray-700">Start Date</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    id={'End_of_frequency'}
                                                    type="radio"
                                                    value="End of frequency"
                                                    className="custom-radio"
                                                    {...register("interest_payout_date", {
                                                        required: true,
                                                    })}
                                                />
                                                <label htmlFor="End_of_frequency" className="block text-sm font-medium text-gray-700">End of frequency</label>
                                            </div>

                                        </div>
                                    </div>
                                    <div>
                                        {errors.interest_payout_date && (
                                            <Label title={"Please Select Interest Payout Date."} modeError={true} />
                                        )}
                                    </div>
                                </div>
                            }

                            <div className="col-span-8">
                                <label className="label">
                                    Notes
                                </label>
                                <textarea
                                    className="form-control form-control-textarea"
                                    placeholder="Notes"
                                    rows={4}
                                    {...register("notes")}
                                />
                            </div>

                        </div>
                    </div>
                    <div className="text-center mt-4">
                        <button
                            type="button"
                            className="btn btn-white mr-3"
                            onClick={goBack}
                        >
                            Cancel
                        </button>
                        <button className="btn btn-brand" type="submit">
                            {isLoading && <img src={loader} className="spinner" />}
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};
export default AddFixedReturnandRetirementProducts;
